import { combineReducers } from "redux";
import { getFailureActionType, getSuccessActionType } from "../../utils";
import {
  CHANGE_BLOCKING_TIMESLOT_REQUEST,
  FETCH_TIMESLOTS_REQUEST,
  UPDATE_BOOKING_FORCESHOW_TIMESLOT_REQUEST,
} from "../constants";
import { TimeslotAction, BookingAction, TimeslotItems, IsFetching } from "../types";

function items(state: TimeslotItems = [], action: TimeslotAction | BookingAction): TimeslotItems {
  let officeId = action.data ? action.data.officeId : 0;
  let selectedOfficeTimeslot = null;

  switch (action.type) {
    case getSuccessActionType(FETCH_TIMESLOTS_REQUEST):
      return { ...state, [officeId]: action.payload };

    case CHANGE_BLOCKING_TIMESLOT_REQUEST:
      selectedOfficeTimeslot = state[officeId].map((timeslot) =>
        timeslot.id === action.data.timeslotId
          ? {
              ...timeslot,
              isFetching: true,
            }
          : timeslot
      );
      return { ...state, [officeId]: selectedOfficeTimeslot };

    case getSuccessActionType(CHANGE_BLOCKING_TIMESLOT_REQUEST):
      selectedOfficeTimeslot = state[officeId].map((timeslot) =>
        timeslot.id === action.payload.id
          ? {
              ...timeslot,
              blocked: action.payload.blocked,
              isFetching: false,
            }
          : timeslot
      );
      return { ...state, [officeId]: selectedOfficeTimeslot };

    case getFailureActionType(CHANGE_BLOCKING_TIMESLOT_REQUEST):
      selectedOfficeTimeslot = state[officeId].map((timeslot) =>
        timeslot.id === action.data.timeslotId
          ? {
              ...timeslot,
              isFetching: false,
            }
          : timeslot
      );
      return { ...state, [officeId]: selectedOfficeTimeslot };

    case UPDATE_BOOKING_FORCESHOW_TIMESLOT_REQUEST:
      selectedOfficeTimeslot = state[officeId].map((timeslot) =>
        timeslot.id === action.data.timeslotId
          ? {
              ...timeslot,
              isFetching: true,
            }
          : timeslot
      );
      return { ...state, [officeId]: selectedOfficeTimeslot };

    case getSuccessActionType(UPDATE_BOOKING_FORCESHOW_TIMESLOT_REQUEST):
      selectedOfficeTimeslot = state[officeId].map((timeslot) =>
        timeslot.id === action.data.timeslotId
          ? {
              ...timeslot,
              forceShow: action.payload.forceShow,
              isFetching: false,
            }
          : timeslot
      );
      return { ...state, [officeId]: selectedOfficeTimeslot };

    case getFailureActionType(UPDATE_BOOKING_FORCESHOW_TIMESLOT_REQUEST):
      selectedOfficeTimeslot = state[officeId].map((timeslot) =>
        timeslot.id === action.data.timeslotId
          ? {
              ...timeslot,
              isFetching: false,
            }
          : timeslot
      );
      return { ...state, [officeId]: selectedOfficeTimeslot };

    default:
      return state;
  }
}

function isFetching(state: IsFetching = {}, action: TimeslotAction): IsFetching {
  let officeId = action.data ? action.data.officeId : 0;
  switch (action.type) {
    case FETCH_TIMESLOTS_REQUEST:
      return { ...state, [officeId]: true };
    case getSuccessActionType(FETCH_TIMESLOTS_REQUEST):
    case getFailureActionType(FETCH_TIMESLOTS_REQUEST):
      return { ...state, [officeId]: false };

    default:
      return state;
  }
}

export const timeslots = combineReducers({ items, isFetching });
